import { Component, EventEmitter, inject, Input, input, Output } from '@angular/core';
import { faCommentPlus } from '@fortawesome/pro-regular-svg-icons';
import { QuestionType } from '@empathy/survey/base';

import { SideTabs } from '../../../models/side-tabs.enum';
import { EditingSourceVariable } from '../../../models/sources/survey-editor-sources.model';
import { TextEditorSettings } from '../../../models/text-editor-settings.model';
import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-variable-form',
  templateUrl: 'variable-form.component.html',
  styleUrls: ['./variable-form.component.scss']
})
export class VariableFormComponent {
  @Input() activeVariable: EditingSourceVariable;
  @Output() addComment = new EventEmitter();

  canComment = input(true);

  faCommentPlus = faCommentPlus;
  inputSettings = new TextEditorSettings('input', false);
  questionType = QuestionType;

  private surveyEditorService = inject(SurveyEditorService);

  onAddNewComment(): void {
    this.surveyEditorService.activeTab$.set(SideTabs.Comments);
    this.addComment.emit(this.activeVariable.variable.get('id').value);
  }
}
